import { useCallback, useEffect } from 'react';

import { useShowCommentsPanel } from '@confluence/comments-panel';
import { useCommentsPanelActions, useCommentsPanelScroll } from '@confluence/comments-panel-utils';
import { useCommentService } from '@confluence/content-types-bridge-comments';

export const useRegisterCommentsPanelCallbacks = () => {
	const { commentService } = useCommentService();
	const { isCommentsPanelShown, showCommentsPanel } = useShowCommentsPanel();
	const { setCurrentlySelectedThreadKey } = useCommentsPanelActions();
	const { scrollCommentsPanelToThread } = useCommentsPanelScroll();

	const showPanelHandler = useCallback(() => {
		if (!isCommentsPanelShown) {
			showCommentsPanel();
		}
	}, [isCommentsPanelShown, showCommentsPanel]);

	const setCommentThreadHandler = useCallback(
		(threadId?: string) => {
			// highlight a comment in sidebar
			// if threadId is undefined, it means we are de-selecting
			setCurrentlySelectedThreadKey(threadId);
			if (threadId) {
				// scroll to the comment thread in the sidebar
				scrollCommentsPanelToThread({
					annotationId: threadId,
					annotationClicked: true,
				});
			}
		},
		[setCurrentlySelectedThreadKey, scrollCommentsPanelToThread],
	);

	useEffect(() => {
		commentService.registerSelectCommentThreadHandler(setCommentThreadHandler);
	}, [commentService, setCommentThreadHandler]);

	useEffect(() => {
		commentService.registerShowPanelHandler(showPanelHandler);
	}, [commentService, showPanelHandler]);
};
